import { requireScript } from "./../helpers/require-script";
import documentReady from "./../helpers/document-ready";

const handleFormSecurity = (tokenFieldName, tokenId) => {
    let url = APP_DOMAIN + "/_form_params/";
    if (tokenId) url += `?token_id=${tokenId}`;

    return fetch(url, { credentials: "include" })
        .then((resp) => resp.json())
        .then((result) => {
            Array.from(document.getElementsByName(tokenFieldName || "_csrf_token")).forEach(
                (el) => (el.value = result.token),
            );

            if (result.needs_captcha) {
                handleCaptcha();
            }
        });
};

window.onRecaptchaScriptLoaded = () => {
    documentReady(() => {
        const hasRecaptchaHolder = !!document.getElementById("recaptcha_holder");

        if (!hasRecaptchaHolder) {
            return;
        }

        window.grecaptcha.render("recaptcha_holder", {
            sitekey: "6LdHHAcUAAAAACOdiyUe67H3Ym6s1kKeetuiuFjd",
        });
    });
};

const handleCaptcha = () => {
    requireScript(
        "https://www.google.com/recaptcha/api.js?onload=onRecaptchaScriptLoaded&render=explicit",
    );
};

export { handleFormSecurity, handleCaptcha };
